import React from "react";
import { Link } from "react-router-dom";
import IRMA from "@models/IRMA";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwPill from "@components/shared/OwPill/OwPill";
import RmaStatusEnum from "@models/RmaStatusEnum";
import UIService from "@services/UIService";
import "./RmaDetailHeader.scss";
import UserService from "@services/UserService";
import RmaService from "@services/RmaService";

type Props = {
    rma: IRMA;
};

export const RmaDetailHeader = (props: Props) => {
    const { rma } = props;

    const formatDate = (date: Date | string | null | undefined): string => {
        if (!date) return "-";
        return UserService.parseDate(new Date(date));
    };

    return (
        <div className="RmaDetailHeader">
            <div className="d-flex justify-content-between align-items-start mb-3">
                <div>
                    <h2 className="mb-2">
                        {rma.rma_number}{" "}
                        <OwPill className={RmaService.getStatusBadgeColor(rma.rma_status_id)} title={rma.RMA_Status?.name || "unknown"} />
                    </h2>
                    <div className="text-muted">
                        {rma.Vendor && (
                            <>
                                <span className="me-3">
                                    <OwLabel title="customer" isBold={true} noBottomMargin={true} />: {rma.Vendor.name}
                                </span>
                            </>
                        )}
                        {rma.Order && (
                            <>
                                <span className="me-3">
                                    <OwLabel title="order" isBold={true} noBottomMargin={true} />:{" "}
                                    <Link to={`/orders/${rma.Order.guid}/entry`}>{rma.Order.name}</Link>
                                </span>
                            </>
                        )}
                        {rma.Warehouse && (
                            <>
                                <span>
                                    <OwLabel title="warehouse" isBold={true} noBottomMargin={true} />: {rma.Warehouse.name}
                                </span>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-md-3">
                    <OwLabel title="created_at" isBold={true} />
                    <div>{formatDate(rma.created_at)}</div>
                </div>
                {rma.authorized_at && (
                    <div className="col-md-3">
                        <OwLabel title="authorized_at" isBold={true} />
                        <div>{formatDate(rma.authorized_at)}</div>
                    </div>
                )}
                {rma.received_at && (
                    <div className="col-md-3">
                        <OwLabel title="received_at" isBold={true} />
                        <div>{formatDate(rma.received_at)}</div>
                    </div>
                )}
                {rma.processed_at && (
                    <div className="col-md-3">
                        <OwLabel title="processed_at" isBold={true} />
                        <div>{formatDate(rma.processed_at)}</div>
                    </div>
                )}
            </div>

            {rma.tracking_number && (
                <div className="row mb-3">
                    <div className="col-md-6">
                        <OwLabel title="tracking_number" isBold={true} />
                        <div>{rma.tracking_number}</div>
                    </div>
                </div>
            )}
        </div>
    );
};
